import React from "react";
import type { AppMode } from "../hooks/useTranslator";
import { useUiLang } from "../../../context/UiLangContext";

interface HeaderLangSelectorsProps {
  appMode: AppMode;
  recording: boolean;
  srcLang: string;
  tgtLang: string;
  fromLabel: string;
  toLabel: string;
  minutaInLabel: string;
  setSrcLang: (lang: string) => void;
  setTgtLang: (lang: string) => void;
}

const selectStyle = {
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' fill='none'%3E%3Cpath d='M1 1l3 3 3-3' stroke='%23aaa' stroke-width='1.2' stroke-linecap='round'/%3E%3C/svg%3E")`,
  backgroundRepeat: "no-repeat" as const,
  backgroundPosition: "right 7px center",
};

export const HeaderLangSelectors: React.FC<HeaderLangSelectorsProps> = ({
  appMode,
  recording,
  srcLang,
  tgtLang,
  fromLabel,
  toLabel,
  minutaInLabel,
  setSrcLang,
  setTgtLang,
}) => {
  const { uiLang } = useUiLang();
  const isEn = uiLang === "en";

  return (
    <div className="flex items-center gap-[4px] flex-shrink-0">
      <span className="text-[10px] font-[700] text-[var(--text-dim)] tracking-[0.04em] whitespace-nowrap">{fromLabel}</span>
      <select
        value={srcLang}
        onChange={(e) => setSrcLang(e.target.value)}
        disabled={recording}
        aria-label={isEn ? "Source language" : "Idioma de origen"}
        className="font-sans text-[12px] font-[500] bg-white dark:bg-[var(--surface)] border border-[var(--border)] text-[var(--text)] rounded-[8px] px-[10px] pr-[24px] h-[27px] cursor-pointer outline-none appearance-none transition-all duration-150 hover:bg-[var(--bg4)] focus:border-[var(--accent)] disabled:opacity-50 disabled:cursor-not-allowed"
        style={selectStyle}
      >
        <option value="auto">{isEn ? "Auto-detect (Multilingual)" : "Auto-detectar (Multilingüe)"}</option>
        <option value="en">{isEn ? "English" : "Inglés"}</option>
        <option value="es">{isEn ? "Spanish" : "Español"}</option>
      </select>
      <span className="text-[12px] text-[var(--text-dim)]">→</span>
      <span className="text-[10px] font-[700] text-[var(--text-dim)] tracking-[0.04em] whitespace-nowrap">{toLabel}</span>
      <select
        value={tgtLang}
        onChange={(e) => setTgtLang(e.target.value)}
        disabled={recording}
        aria-label={isEn ? "Target language" : "Idioma de destino"}
        className="font-sans text-[12px] font-[500] bg-white dark:bg-[var(--surface)] border border-[var(--border)] text-[var(--text)] rounded-[8px] px-[10px] pr-[24px] h-[27px] min-w-[100px] cursor-pointer outline-none appearance-none transition-all duration-150 hover:bg-[var(--bg4)] focus:border-[var(--accent)] disabled:opacity-50 disabled:cursor-not-allowed"
        style={selectStyle}
      >
        <option value="es">{isEn ? "Spanish" : "Español"}</option>
        <option value="en">{isEn ? "English" : "Inglés"}</option>
      </select>
    </div>
  );
};
